import {
  ApiModule,
  CookieModule,
  DatadogModule,
  LocalStorageModule,
  LoggerModule,
  SessionStorageModule,
  TokenModule,
} from "@packages/common";
import {
  AdobeModule,
  AuthModule,
  FavoritesModule,
  UserModule,
} from "@packages/domain";
import type { Module } from "@webmotors/ioc";
import { createConfigModule, EnvironmentType } from "@/config";
import { QueriesModule } from "./queries/queries.module";

export const AppModule: Module = {
  name: "AppModule",
  modules: [
    createConfigModule(
      (process.env.NEXT_PUBLIC_ENVIRONMENT as EnvironmentType) ??
        EnvironmentType.LOCAL
    ),
    ApiModule,
    CookieModule,
    DatadogModule,
    LocalStorageModule,
    LoggerModule,
    SessionStorageModule,
    TokenModule,
    AuthModule,
    UserModule,
    FavoritesModule,
    AdobeModule,
    QueriesModule,
  ],
};
